import { NgModule } from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { AdminLayoutModule } from '../../admin-layout/admin-layout.module';
import { SharedModule } from '../../shared/shared.module';
import { AfterValueChangedDirective } from '../../core/directives/after-value-changed.directive';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { CoreModule } from '../../core/core.module';
import { UserProfileAttachmentsComponent } from './user-profile/user-profile-attachments/user-profile-attachments.component';
import { AnnualVacationQuotaDialogComponent } from './dialogs/annual-vacation-quota-dialog/annual-vacation-quota-dialog.component';
import { WorkingTimeDialogComponent } from './dialogs/working-time-dialog/working-time-dialog.component';
import { UserService } from './services/user.service';
import { UserDetailDataStore } from './state-and-data-handling/user-detail-data-store.service';
import { UserProfileComponent } from './user-profile/user-profile.component';
import { UserProfileDataComponent } from './user-profile/user-profile-data/user-profile-data.component';
import { UserProfilePersonalDataComponent } from './user-profile/user-profile-data/user-profile-personal-data/user-profile-personal-data.component';
import { UserProfileEmploymentDataComponent } from './user-profile/user-profile-data/user-profile-employment-data/user-profile-employment-data.component';
import { UserProfileSalaryDataComponent } from './user-profile/user-profile-data/user-profile-salary-data/user-profile-salary-data.component';
import { UserProfileSocialSecurityComponent } from './user-profile/user-profile-data/user-profile-social-security/user-profile-social-security.component';
import { UserDataService } from './state-and-data-handling/user-data.service';

@NgModule({
  declarations: [
    UserProfileComponent,
    UserProfileDataComponent,
    UserProfilePersonalDataComponent,
    UserProfileEmploymentDataComponent,
    UserProfileSalaryDataComponent,
    UserProfileAttachmentsComponent,
    AnnualVacationQuotaDialogComponent,
    WorkingTimeDialogComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    AfterValueChangedDirective,
    FaIconComponent,
    NgOptimizedImage,
    CoreModule,
    UserProfileSocialSecurityComponent,
    AdminLayoutModule,
  ],
  providers: [UserDetailDataStore, UserDataService, UserService],
})
export class UserModule {}
